import {
  EXPERIMENTATION_ADDED,
  EXPERIMENTATION_DELETED,
  EXPERIMENTATION_REPORT_SET,
  EXPERIMENTATION_SET,
  EXPERIMENTATION_STATUS_UPDATE,
} from 'src/app/redux/redux-types';
import { reduxActionTypes, reduxExperimentationTypes } from 'src/types';

export const experimentationDefaultState: reduxExperimentationTypes.StateType = {
  experimentationList: [],
  experimentationReport: undefined,
};

export const experimentationReducer = (
  state = experimentationDefaultState,
  action: reduxExperimentationTypes.ActionType,
): reduxExperimentationTypes.StateType => {
  switch (action.type) {
    case EXPERIMENTATION_SET:
      return {
        ...state,
        experimentationList: action.payload,
      };
    case EXPERIMENTATION_ADDED:
      return {
        ...state,
        experimentationList: [action.payload, ...state.experimentationList],
      };
    case EXPERIMENTATION_DELETED:
      return {
        ...state,
        experimentationList: state.experimentationList.filter((item) => item.id !== action.payload),
      };
    case EXPERIMENTATION_REPORT_SET:
      return {
        ...state,
        experimentationReport: action.payload,
      };
    case EXPERIMENTATION_STATUS_UPDATE:
      return {
        ...state,
        experimentationList: state.experimentationList.map((item) =>
          item.id === action.payload.id ? { ...item, status: action.payload.status } : item,
        ),
      };

    default:
      return state;
  }
};
